var _rect, _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommunityOnetooneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 28,
    viewBox: "0 0 53 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 28,
    rx: 6,
    fill: "#FF3A99",
    fillOpacity: 0.1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.9999,
    cy: 11.3333,
    r: 2.66667,
    fill: "#FF3A99"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6669 18.0001V17.3591C10.6668 17.3505 10.6667 17.3419 10.6667 17.3333C10.6667 16.2288 11.5622 15.3333 12.6667 15.3333L12.685 15.3334H19.3336C20.4381 15.3334 21.3336 16.2288 21.3336 17.3334V18.0001C21.3336 18.7365 20.7366 19.3334 20.0002 19.3334L19.3336 19.3334L12.0002 19.3334C11.2639 19.3334 10.6669 18.7365 10.6669 18.0001Z",
    fill: "#FF3A99"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2072 9.51381L28.1022 10.8729V12.2693L30.087 11.0014H30.1367V18H31.6657V9.51381H30.2072ZM35.502 12.7707C35.9909 12.7707 36.4053 12.3646 36.4094 11.8633C36.4053 11.366 35.9909 10.9641 35.502 10.9641C35.0006 10.9641 34.5862 11.366 34.5945 11.8633C34.5862 12.3646 35.0006 12.7707 35.502 12.7707ZM35.502 16.9765C35.9909 16.9765 36.4053 16.5704 36.4094 16.0691C36.4053 15.5718 35.9909 15.1699 35.502 15.1699C35.0006 15.1699 34.5862 15.5718 34.5945 16.0691C34.5862 16.5704 35.0006 16.9765 35.502 16.9765ZM40.7759 9.51381L38.671 10.8729V12.2693L40.6558 11.0014H40.7055V18H42.2345V9.51381H40.7759Z",
    fill: "#FF3A99"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunityOnetooneIcon);
export default __webpack_public_path__ + "static/media/community_onetoone_icon.6540db4f1281200c48af9ff7c6fa513e.svg";
export { ForwardRef as ReactComponent };